import AScene from "../../library/ExtendedObjects/AScene.js";
import Game from "./Game.js";
import gameData from "../../gameData.js";
import Utils from "../../library/Utils.js";
import Dollar from "./Dollar.js";

export default class Game_Sorting extends Game
{
    create()
    {
        super.create();

        let coinTabs = ["SortTab_1c", "SortTab_5c", "SortTab_10c", "SortTab_25c"];
        let dollarTabs = ["SortTab_1d", "SortTab_5d", "SortTab_10d", "SortTab_20d", "SortTab_50d", "SortTab_100d"];

        this.tabKeys = [];
        if(gameData.denominations == gameData.denominationTypes.COINS) this.tabKeys = coinTabs;
        else if(gameData.denominations == gameData.denominationTypes.DOLLARS) this.tabKeys = dollarTabs;
        else this.tabKeys = coinTabs.concat(dollarTabs);

        this.tabs = [];
        this.tabContainer = this.add.container(0, 900);
        let startX = [80, 50, 19];
        let lastX = startX[gameData.denominations]
        let spacings = [180, 80, 17];
        for(let i = 0; i < this.tabKeys.length; i++)
        {
            let tab = this.addImage(0, 0, this.tabKeys[i], this.tabContainer);
            tab.x = lastX + tab.width * .5;
            lastX = tab.x + tab.width * .5 + spacings[gameData.denominations];
            this.tabs.push(tab);
        }

        this.activeRegion.height = 620;
        this.currentTab = null;
        this.currentMoney = null;
    }

    pigExploded()
    {
        this.money.forEach((money)=>{
            money.onUp = (m)=>{ this.onMoneyReleased(m); };
            money.onMove = (m)=>{ this.onMoneyMoved(m); };
            money.onDown = (m)=>{ this.onMoneySelected(m); };
        });

        this.addTween(this.tabContainer, 1300, {y: 740, easeParams: [.9, .9]}, "Elastic");
    }

    onMoneySelected(money)
    {
        this.currentMoney = money;
    }

    onMoneyReleased(money)
    {
        if(this.currentTab == null) return;
        let selectedTab = this.currentTab;
        selectedTab.tint = 0xffffff;
        this.setClosestTab(null);

        if(selectedTab.frame.name == money.moneyData.tab)
        {
            money.setScale(.5);
            let tabPos = Utils.StagePos(selectedTab);
            this.playSound("correct_answer");
            this.addTween(money, 200, {x: tabPos.x, y: tabPos.y}, Phaser.Math.Easing.Sine.Out, ()=>{
                let isComplete = this.killMoney(money);
                if(isComplete) 
                {
                    this.answerCorrect();
                    this.addTween(this.tabContainer, 200, {y: 900});
                }
            });
        }
        else 
        {
            this.playSound("incorrect_sorting");
            this.addTween(selectedTab, 120, {tint: 0xff0000, repeat: 1, yoyo: true});
        }
    }

    onMoneyMoved(money)
    {
        let closestTab = null;
        this.tabs.forEach((tab)=>{
            let stagePos = Utils.StagePos(tab);
            let distance = Phaser.Math.Distance.Between(stagePos.x, stagePos.y, money.x, money.y);
            if((closestTab == null || distance < closestTab.mouseDistance) && distance < 200)
            {
                closestTab = tab;
                closestTab.mouseDistance = distance;
            }
        });
        
        this.setClosestTab(closestTab);
    }

    setClosestTab(tab)
    {
        if(tab == this.currentTab) return;
        if(this.currentTab != null) 
        {
            this.currentTab.tint = 0xffffff;
            this.killTween([this.currentMoney, this.currentTab]);
            this.addTween(this.currentTab, 200, {y: 0});
            this.addTween(this.currentMoney, 200, {scaleX: this.currentMoney.designatedScale, scaleY: this.currentMoney.designatedScale});
        }
        this.currentTab = tab;
        if(this.currentTab != null) 
        {
            this.currentTab.tint = 0xaaaaff;
            this.killTween([this.currentMoney, this.currentTab]);
            this.addTween(this.currentTab, 200, {y: -20});
            if(this.currentMoney instanceof Dollar)
            {
                this.addTween(this.currentMoney, 200, {scaleX: .5, scaleY: .5});
            } else {
                this.addTween(this.currentMoney, 200, {scaleX: this.currentMoney.designatedScale * .8, scaleY: this.currentMoney.designatedScale * .8});
            }
        }
    }
}